import { FormBuilderConfig } from '../models/form-builder-config.model';

export interface FormSaverResponse {
  response: any,
  config: FormBuilderConfig
}
